import { ref, computed } from 'vue';
import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

interface FunctionalActivity {
  id: number;
  name: string;
  active: boolean;
  departmentId: number | null;
  createdAt: string;
  updatedAt: string;
}

interface FunctionalActivityResponse {
  success: boolean;
  data: FunctionalActivity[];
  metadata: {
    total: number;
    page: number;
    itemsPerPage: number;
    totalPages: number;
  };
}

export function useFunctionalActivityOptions() {
  const functionalActivities = ref<FunctionalActivity[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const functionalActivityOptions = computed(() => {
    return functionalActivities.value.map((activity) => ({
      id: activity.id.toString(),
      name: activity.name,
    }));
  });

  async function loadFunctionalActivities() {
    isLoading.value = true;
    error.value = null;

    try {
      const response = await api.get<FunctionalActivityResponse>('/functional-activities', {
        params: {
          active: true,
          itemsPerPage: 1000,
        },
      });
      functionalActivities.value = response.data?.data || [];
    } catch {
      error.value = 'Erro ao carregar atividades funcionais';
      functionalActivities.value = [];
    } finally {
      isLoading.value = false;
    }
  }

  return {
    functionalActivities,
    functionalActivityOptions,
    isLoading,
    error,
    loadFunctionalActivities,
  };
}
